var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"custom-copy"},[_vm._v(_vm._s(_vm.txt)+" "),_c('span',{staticClass:"btn",on:{"click":function($event){return _vm.handleCopy($event, _vm.txt)}}},[_c('span',{staticClass:"color526bec"},[_vm._v("复制")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }